import { connect } from 'react-redux';
import { getCollectionStores, setCollectionSelectedStore } from 'Favourites/store/actions';
import { selectNoProductsAvailable } from 'Favourites/store/reducers/data/products';

import {
    sortAscByProperty,
} from 'helpers';
import { getText } from 'helpers/i18n';

import {
    selectFilteredStores,
    selectSelectedStoreId,
    selectError,
} from 'store/reducers/data/clickCollect';

const getStores = (state) => [
    {
        name: getText('clickcollect_select_label'),
        value: 0,
    },
    ...window.Checkout.settings.clickcollect.sortAlphabetical ? sortAscByProperty(selectFilteredStores(state), 'name') : selectFilteredStores(state),
];

const mapStateToProps = (state) => {
    return {
        stores: getStores(state),
        selectedStore: selectSelectedStoreId(state),
        noProductsAvailable: selectNoProductsAvailable(state),
        error: selectError(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCollectionStores: () => {
            dispatch(getCollectionStores());
        },
        setSelectedStore: (storeName, storeId) => {
            window.Checkout.analytics.logEcommerceEvent({
                name: 'set_checkout_option',
                params: {
                    checkout_step: 1,
                    checkout_option: 'delivery method - pick up in store: ' + storeId,
                },
            });
            dispatch(setCollectionSelectedStore(storeId));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
